export default __webpack_public_path__ + "static/media/sale-day.8cf03140.svg";